import { createSyncStoragePersister } from '@tanstack/query-sync-storage-persister';
import { removeOldestQuery } from '@tanstack/react-query-persist-client';
import { compress, decompress } from 'lz-string';
const useCompression = !process.env.PERSISTER_COMPRESS;
const oaStorage = {
    getItem: (key) => {
        var _a;
        let mutations = [], queries = [], state = {};
        for (let i = 0; i < localStorage.length; i++) {
            let skey = (_a = localStorage.key(i)) !== null && _a !== void 0 ? _a : '';
            if (skey.startsWith(`${key}_query`)) {
                let _query = localStorage.getItem(skey);
                if (_query) {
                    queries.push(JSON.parse(useCompression ? decompress(_query) : _query));
                }
            }
            if (skey.startsWith(`${key}_mutation`)) {
                let _mutation = localStorage.getItem(skey);
                if (_mutation) {
                    mutations.push(JSON.parse(useCompression ? decompress(_mutation) : _mutation));
                }
            }
            if (skey.startsWith(`${key}_state`)) {
                let _state = localStorage.getItem(skey);
                if (_state) {
                    state = JSON.parse(useCompression ? decompress(_state) : _state);
                }
            }
        }
        let persistedClient = {
            buster: state.buster,
            timestamp: state.timestamp,
            clientState: {
                queries: queries,
                mutations: mutations
            }
        };
        // The Storage type interface of react-query is wrong, this shouldn't
        // return a string but a PersistedClient, which we do
        //@ts-ignore
        return persistedClient;
    },
    removeItem: (key) => {
        var _a;
        for (let i = 0; i < localStorage.length; i++) {
            let skey = (_a = localStorage.key(i)) !== null && _a !== void 0 ? _a : '';
            if (skey.startsWith(`${key}_`)) {
                localStorage.removeItem(skey);
            }
        }
    },
    setItem: (key, value) => {
        oaStorage.removeItem(key);
        let item = JSON.parse(value);
        let state = {
            buster: item.buster,
            timestamp: item.timestamp
        };
        item.clientState.mutations.forEach((value, i) => {
            localStorage.setItem(`${key}_mutation_${i}`, useCompression ? compress(JSON.stringify(value)) : JSON.stringify(value));
        });
        item.clientState.queries.forEach((value, i) => {
            localStorage.setItem(`${key}_query_${i}`, useCompression ? compress(JSON.stringify(value)) : JSON.stringify(value));
        });
        localStorage.setItem(`${key}_state`, useCompression ? compress(JSON.stringify(value)) : JSON.stringify(state));
    },
};
export function createLocalStoragePersister() {
    return createSyncStoragePersister({
        storage: oaStorage,
        retry: removeOldestQuery,
        throttleTime: 1000, // default value, just here so we know it exists
        key: 'oaQuery',
        serialize: (data) => {
            return JSON.stringify(data);
        },
        // this is also wrong, but here it's the deserialize prototype thats wrong
        // data isn't a string, but a PersistedClient
        //@ts-ignore
        deserialize: (data) => {
            return data;
        }
    });
}
